import { createPortal } from "react-dom";

export default function EditQuestionModal({
  open,
  questionText,
  saving,
  onChange,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="admin-modal-backdrop fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit-question-title"
    >
      <div className="relative w-full max-h-[90vh] overflow-auto">
        <div className="admin-modal-card relative bg-white rounded-lg shadow max-w-xl mx-auto">
          <div className="flex items-center justify-between p-4 md:p-5 border-b admin-modal-divider rounded-t">
            <h3
              id="edit-question-title"
              className="text-xl font-semibold admin-modal-title"
            >
              Edit Question
            </h3>
            <button
              type="button"
              className="admin-modal-muted hover:bg-gray-200 hover:text-gray-900 rounded-lg text-2xl leading-none w-10 h-10 inline-flex justify-center items-center"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <div className="p-4 md:p-5 space-y-4">
            <input
              type="text"
              value={questionText}
              onChange={(e) => onChange(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-sm rounded-lg w-full p-2.5"
              placeholder="Type here..."
              aria-labelledby="edit-question-title"
              required
            />

            <div className="flex items-center justify-center gap-4 pt-2">
              <button
                type="button"
                className="px-6 py-2 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
                onClick={onClose}
                disabled={saving}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={saving || !questionText.trim()}
                className="px-6 py-2 rounded-full font-medium text-white bg-[#004F73] hover:opacity-90 disabled:opacity-50"
              >
                {saving ? "Saving…" : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
